module.exports = __webpack_public_path__ + "img/Dantam Bridal 11.b1dbc88c.jpg";